 import { axiosInstance } from 'network/apis';

export const loginRequest = async (payload) => {
  return await axiosInstance.post(`login`,payload,  { handlerEnabled: false })
};

export const updatePasswordRequest = async (payload) => {
  return await axiosInstance.post(`/user/${payload.userId}`,{password: payload.password, token: payload.token}, { handlerEnabled: false })
};


function updateAccountSelection (accountId) {
  return axiosInstance.post('salesforce/getSalesforceClientsWithFilter', {projectAccountId: accountId}, { handlerEnabled: true })
}

// QUAL-2135: isI2andQsToolUser (POST reset-user-password/check-qsTool-i2) removed. It asked
// the API whether an address belonged to a real user and which products that user had, and
// returned the answer to anyone who asked - the user-enumeration oracle in the finding. The
// login screen now takes one path for every address, so there is nothing to ask.

function sendResetPasswordEmailRequest (payload) {
  return axiosInstance.post(`reset-user-password/send-user-password-email`, {email: payload.resetPasswordEmail}, { handlerEnabled: false })
}

export default {
    loginRequest,
    updatePasswordRequest,
    updateAccountSelection,
    sendResetPasswordEmailRequest
};
